// chatroomConstants.js
'use strict';

export const chatroomListType = {
  ALL: 'all',
  READ: 'read',
  UNREAD: 'unread',
  PIN: 'pin',
};

export const MIN_CHATROOM_MESSAGES_PAGE_SIZE_LIMIT = 20;

export const MAX_CHATROOM_MESSAGES_PAGE_SIZE_LIMIT = 100;

export const FAKE_CHAT_ID = 'fake-chat';

export const DESKTOP_TOP_MARGIN_OFFSET = 64;

export const DESKTOP_CHATROOMS_WIDTH = 360;
